import '../App.css';
import axios from 'axios';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Device from './Device';
import Header from '../Header';

function Devices() {
    const navigate = useNavigate();
    const [devices, setDevices] = useState([]);

    function loadDevices() {
        axios.get(
            process.env.REACT_APP_API_HOST + '/devices/',
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            },
        ).then(
            (response) => {
                setDevices(response.data);
            }
        ).catch(
            (error) => {
                // TODO: remove dup.
                localStorage.removeItem('token');
                localStorage.removeItem('user_id');
                navigate('/');
            }
        )
    }

    const divDevices = devices.map(
        d =>
            <Device
                device={d}
                loadDevices={loadDevices}
            />
    )

    useEffect(
        () => {
            loadDevices();
        },
        [],
    )

    return (
        <div style={{ marginTop: '4em' }}>
            <Header />
            <div
                className='standard-box2'
                style={{ width: '90%', marginTop: '2em' }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <Button
                            label="Setup New Device"
                            severity="success"
                            onClick={
                                () => {
                                    navigate('/devices/new/');
                                }
                            }
                            style={{ marginLeft: '0.4em' }}
                            size='small'
                        />
                    </div>
                </div>
            </div>
            <div
                className='standard-box3'
                style={{ width: '90%' }}
            >
                {divDevices}
            </div>
        </div>
    );
}

export default Devices;